import React, { useState, useEffect, useCallback } from "react";
import { Container, Form, Button, Card, Spinner } from "react-bootstrap";
import api from "../api/api";
import { useNavigate, useParams } from "react-router-dom";

const EditUser = () => {
  const [userData, setUserData] = useState({
    email: "",
    first_name: "",
    last_name: "",
    mobile: "",
    date_of_birth: "",
    receives_sms: true,
    receives_email: true,
    is_active: true,
    agreed_to_terms: false,
  });
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();
  const { userId } = useParams();

  const fetchUserDetails = useCallback(async () => {
    try {
      setLoading(true);
      const currentUserId = localStorage.getItem("user_id");
      const endpoint = String(userId) === String(currentUserId)
        ? "/users/me/"
        : `/users/${userId}/`;
      const response = await api.get(endpoint);
      setUserData(response.data);
      setLoading(false);
    } catch (error) {
      setError("Failed to load user details");
      setLoading(false);
      console.error(error);
    }
  }, [userId]);
  useEffect(() => {
    fetchUserDetails();
  }, [userId, fetchUserDetails]);


  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setUserData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setMessage("");
    setError("");

    try {
      const response = await api.put(`/users/${userId}/`, userData);

      if (response.status === 200) {
        setMessage("User updated successfully!");
        setTimeout(() => navigate(`/user/${userData.id}`), 1500);
      } else {
        setError("Failed to update user. Please try again.");
      }
    } catch (error) {
      setError(
        error.response?.data?.message ||
          "Failed to update user. Please try again."
      );
      console.error(error);
    }
  };

  if (loading) {
    return (
      <Container
        className="d-flex mb-3 justify-content-center align-items-center"
        style={{ minHeight: "50vh" }}
      >
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  return (
    <Container className="d-flex justify-content-center align-items-center py-4">
      <div className="row w-100 justify-content-center">
        <div className="col-12 col-md-6">
          <Card className="mb-4">
            <Card.Body>
              <h2 className="text-center mb-4">Edit Profile</h2>

              <Form onSubmit={handleSubmit} className="mb-3">
                <Form.Group className="mb-3" controlId="formEmail">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={userData.email}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formFirstName">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="first_name"
                    value={userData.first_name}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formLastName">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="last_name"
                    value={userData.last_name}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formMobile">
                  <Form.Label>Mobile</Form.Label>
                  <Form.Control
                    type="tel"
                    name="mobile"
                    value={userData.mobile}
                    onChange={handleInputChange}
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formDateOfBirth">
                  <Form.Label>Date of Birth</Form.Label>
                  <Form.Control
                    type="date"
                    name="date_of_birth"
                    value={userData.date_of_birth || ""}
                    onChange={handleInputChange}
                  />
                </Form.Group>

                <div className="mt-4 mb-3">
                  <Button variant="primary" type="submit" className="w-100">
                    Update User
                  </Button>
                </div>

                {message && (
                  <div className="text-center mt-3 text-success">{message}</div>
                )}
                {error && (
                  <div className="text-center mt-3 text-danger">{error}</div>
                )}
              </Form>
            </Card.Body>
          </Card>
        </div>
      </div>
    </Container>
  );
};

export default EditUser;
